import {Component, Injector, OnInit} from '@angular/core';
import {UserService} from '../services/user.service';
import {SnackBarService} from '../services/snack-bar.service';
import {Router} from '@angular/router';
import {SharedService} from '../services/shared.service';
import {ImageCroppedEvent, ImageCropperComponent} from 'ngx-image-cropper';
import {MatDialog} from '@angular/material/dialog';
import {ImageEditorComponent} from '../dialogs/image-editor/image-editor.component';
import {PomodoroRepository} from '../Models/PomodoroRepository';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {
  public infoSpinner = false;
  public checkMode: any;
  public userMobile;
  public showEditPic = false;
  public pomodoroRepository: PomodoroRepository;
  public user = {
    name: '',
    email: '',
    mobile: '',
    profile_photo_url: '',
    profile_photo: ''
  };
  public password = {
    password: '',
    password_confirmation: '',
  };
  imageChangedEvent: any = '';
  croppedImage: any = '';
  fileToUpload: File = null;
  public registerSpinner = false;
  public mobile;
  public removeImageSpinner = false;
  public firstSpinner = false;
  public secondSpinner = false;
  public userId;
  public ctrl;
  public error: any;
  public isRegister: any;
  constructor(private userService: UserService,
              private snackBar: SnackBarService,
              private router: Router,
              public sharedService: SharedService,
              private dialog: MatDialog,
              injector: Injector) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
    this.mobile = localStorage.getItem('mobile');
    if (localStorage.getItem('username') === null) {
      this.user.name = '';
    } else {
      // tslint:disable-next-line:radix
      this.user.name = localStorage.getItem('username');
    }
    if (this.user.name === null) {
      this.user.name = '';
    }
    this.getCurrentUser();
  }

  setPassword(): any {
    this.secondSpinner = true;
    this.userService.setPassword(this.password).subscribe(
      () => {
        if (localStorage.getItem('trans') === 'fa') {
          this.snackBar.showSnackBar('رمز عبور با موفقیت تعیین شد', 'green-snackbar');
        } else if (localStorage.getItem('trans') === 'en') {
          this.snackBar.showSnackBar('The password has been chosen successfully.', 'green-snackbar');
        }
        this.secondSpinner = false;
      },
      (err) => {
        const myError = JSON.parse(err.error);
        if (localStorage.getItem('trans') === 'fa') {
          // this.snackBar.showSnackBar('رمز عبور انتخابی باید بیشتر از 8 کاراکتر باشد.', 'red-snackbar');
          this.snackBar.showSnackBar(myError.password[0], 'red-snackbar');
        } else if (localStorage.getItem('trans') === 'en') {
          this.snackBar.showSnackBar('The chosen password must be more than 8 characters.', 'red-snackbar');
        }
        this.secondSpinner = false;
      }
    );
  }

  handleFileInput(files: FileList): any {
    this.fileToUpload = files.item(0);
  }

  getCurrentUser(): any {
    this.infoSpinner = true;
    this.userService.getCurrentUserInfo().subscribe(
      (data) => {
        console.log(data.register_with);
        this.isRegister = data.register_with;
        this.userMobile = data.mobile;
        this.user.mobile = data.mobile;
        this.user.name = data.name;
        this.user.email = data.email;
        if (data.profile_photo_url === 'https://api.mypomodoro.ir/profile.png'){
        this.pomodoroRepository.editCtrl = true;
        } else {
          this.pomodoroRepository.editCtrl = false;
          this.pomodoroRepository.profilePhoto = data.profile_photo_url;
        }
        this.infoSpinner = false;
      }
    );
  }

  uploadFile(event): any {
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.user.profile_photo_url = element;
    }
  }

  updateProfileWithImg(): any {
    this.firstSpinner = true;
    this.userService.updateProfileWithImg(this.user).subscribe(
      (data) => {
        localStorage.setItem('username', this.user.name);
        this.showEditPic = false;
        // this.removeProfilePhotoBeforeSendRequest();
        this.snackBar.showSnackBar('تغییرات با موفقیت ذخیره شد', 'green-snackbar');
        this.firstSpinner = false;
      },
      (error) => {
        this.error = error.error;
        if (Object.keys(this.error)[0] === 'mobile'){
          // tslint:disable-next-line:forin
          for (const i in this.error) {
            const child = this.error[i];
            this.snackBar.showSnackBar( child[0], 'red-snackbar');
            break;
          }
        }
        this.firstSpinner = false;
        this.snackBar.showSnackBar(error.error.name[0], 'red-snackbar');
      }
    );
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.showEditPic = true;
  }

  imageCropped(event: ImageCroppedEvent): any {
    this.user.profile_photo = event.base64;
  }

  imageLoaded(): any {
    // show cropper
  }

  cropperReady(): any {
    // cropper ready
  }

  loadImageFailed(): any {
    // show message
  }
  removeProfilePhotoBeforeSendRequest(): any{
    this.pomodoroRepository.profilePhoto = 'https://api.mypomodoro.ir/profile.png';
  }
  removeProfilePhoto(): any {
    this.removeImageSpinner = true;
    this.userService.removeProfilePhoto().subscribe(
      (res) => {
        this.removeImageSpinner = false;
        this.pomodoroRepository.profilePhoto = res.data.profile_photo_url;
        this.pomodoroRepository.editCtrl = true;
      }
    );
  }
  cropImage(): any{
    this.dialog.open(ImageEditorComponent);
  }
}
